import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import ThemeContext from '../../context/ThemeContext';

import './Header.css';

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { theme } = useContext(ThemeContext);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // شماره واتساپ خودت را اینجا بگذار
  const whatsappLink = 'https://wa.me/989399513274';

  return (
    <header className={`header ${theme}`}>
      <div className="header__inner">
        <Link className="header__logo" to="/">
          <img
            src={theme === 'dark' ? '/assets/gif/Vahid.gif' : '/assets/gif/Vahid2.gif'}
            alt="Logo"
            className="header__logoImg"
          />
        </Link>

        <nav className="header__nav">
          <ul>
            <li>
              <Link className={`nav__link ${theme}`} to="/">
                Work
              </Link>
            </li>
            <li>
              <Link className={`nav__link ${theme}`} to="/about">
                About
              </Link>
            </li>
          </ul>
        </nav>

        <div className="header__actions">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ctaButton"
          >
            <span>Contact</span>
            <span className="ctaButton__icon">→</span>
          </a>

          <button className={`hamburger ${theme}`} onClick={toggleSidebar} aria-label="Open menu">
            &#9776;
          </button>
        </div>
      </div>

      {isSidebarOpen && <Sidebar toggleSidebar={toggleSidebar} />}
    </header>
  );
};

export default Header;
